import {
  Box,
  ExpandableSection,
  SpaceBetween,
  TextContent,
} from "@amzn/awsui-components-react";
import ReactJson from "react-json-view";
import { AccountingEventsGroup } from "../../types";
import { AccountingEventsSummarySection } from "./AccountingEventsSummarySection";

interface AccountingEventsViewProps {
  accountingEvents: AccountingEventsGroup["accountingEvents"];
  jsonViewProps: any;
}

export function AccountingEventsView({
  accountingEvents,
  jsonViewProps,
}: AccountingEventsViewProps) {
  const revenueEventKey = accountingEvents
    ? Object.keys(accountingEvents).find((key) => key.includes("REVENUE"))
    : null;
  const revenueEvent = revenueEventKey
    ? accountingEvents[revenueEventKey]
    : null;

  return (
    <SpaceBetween size="l">
      {revenueEvent && <AccountingEventsSummarySection event={revenueEvent} />}

      {accountingEvents &&
        Object.keys(accountingEvents).map((key) => (
          <SpaceBetween size="xl" key={key}>
            <ExpandableSection
              header={
                <Box variant="h4" margin={{ top: "xxs" }}>
                  {key}
                  <br />
                  {accountingEvents[key].creationDate && (
                    <TextContent>
                      <small>
                        Created on:{" "}
                        {new Date(accountingEvents[key].creationDate)
                          .toISOString()
                          .replace("T", " ")}
                      </small>
                    </TextContent>
                  )}
                </Box>
              }
              variant="container"
            >
              <ReactJson src={accountingEvents[key]} {...jsonViewProps} />
            </ExpandableSection>
          </SpaceBetween>
        ))}
    </SpaceBetween>
  );
}
